"use client";

import { toolkitLogoSrc } from "@/features/agents/deploy/workflow-systems";

/** Composio CDN toolkit mark — same source as flow-builder intent chips. */
export function InsightsToolkitLogo({
  system,
  className = "size-3.5 shrink-0 object-contain",
}: {
  system: string;
  className?: string;
}) {
  if (!system.trim()) return null;
  return (
    // eslint-disable-next-line @next/next/no-img-element -- dynamic Composio CDN logos
    <img src={toolkitLogoSrc(system)} alt="" className={className} />
  );
}
